<template>
  <div class="dingding">
    <div class="banner">
      <img class="banner_img" src="../../assets/img/dingding/banner.png" />
      <div class="banner_text">
        <h4>
          让进步发生 让招聘简单
        </h4>
        <p>
          <i></i>
          <span>钉钉首款招聘管理+智能背调应用</span>
        </p>
        <p>
          <i></i>
          <span>钉钉发布会生态合作伙伴</span>
        </p>
        <div class="try" @click="goDingTry" style="cursor:pointer;">立即试用</div>
      </div>
    </div>
    <div class="content1">
      <h6>全流程招聘管理</h6>
      <ul>
        <li>
          <img src="../../assets/img/dingding/process_1.png" />
          <p>筛简历</p>
        </li>
        <li><img src="../../assets/img/dingding/arrow.png" /></li>
        <li>
          <img src="../../assets/img/dingding/process_2.png" />
          <p>待面试</p>
        </li>
        <li><img src="../../assets/img/dingding/arrow.png" /></li>
        <li>
          <img src="../../assets/img/dingding/process_3.png" />
          <p>面试中</p>
        </li>
        <li><img src="../../assets/img/dingding/arrow.png" /></li>
        <li>
          <img src="../../assets/img/dingding/process_4.png" />
          <p>面试通过</p>
        </li>
        <li><img src="../../assets/img/dingding/arrow.png" /></li>
        <li>
          <img src="../../assets/img/dingding/process_5.png" />
          <p>已发Offer</p>
        </li>
        <li><img src="../../assets/img/dingding/arrow.png" /></li>
        <li>
          <img src="../../assets/img/dingding/process_6.png" />
          <p>待入职</p>
        </li>
        <li><img src="../../assets/img/dingding/arrow.png" /></li>
        <li>
          <img src="../../assets/img/dingding/process_7.png" />
          <p>办理入职</p>
        </li>
      </ul>
    </div>
    <div class="content2">
      <ul>
        <li>
          <span class="left">
            <img src="../../assets/img/dingding/content_1.png" />
          </span>
          <div class="gap"></div>
          <span class="right">
            <h6>
              打通招聘平台
            </h6>
            <p>与各大招聘平台打通，满足更多需求</p>
            <p>一键简历获取 | 易招聘简历助手快速查找</p>
            <p>一键岗位导入 | 岗位来源、岗位JD、岗位内容获取</p>
          </span>
        </li>
        <li>
          <span class="left">
            <h6>
              审批中心
            </h6>
            <p>与钉钉官方审批流打通</p>
            <p>招聘需求/录用审批 | 提交录用审批，一键查看候选人面试全流程</p>
          </span>
          <div class="gap"></div>
          <span class="right">
            <img src="../../assets/img/dingding/content_2.png" />
          </span>
        </li>
        <li>
          <span class="left">
            <img src="../../assets/img/dingding/content_3.png" />
          </span>
          <div class="gap"></div>
          <span class="right">
            <h6>
              统计报表
            </h6>
            <p>全方位数据分析，多维度数据展现，直观查看阶段性招聘数据</p>
          </span>
        </li>
        <li>
          <span class="left">
            <h6>
              更多招聘场景
            </h6>
            <p>内推、微官网、猎头、外推</p>
          </span>
          <div class="gap"></div>
          <span class="right">
            <img src="../../assets/img/dingding/content_4.png" />
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {};
  },
  mounted: function () {
    this.$store.dispatch("first_nav_change", "7");
  },
  computed: {},
  methods: {
    goDingTry(){
      let url = 'https://appcenter.dingtalk.com/detail.html?goodsCode=DD_GOODS-101001048911&sig=dabf78575b0f7b9bae7fca43be1efed0'
      window.open(url,'_blank')
    }

  }
};
</script>
<style lang="scss">
.dingding {
  .banner {
    position: relative;

    .banner_img {
      height: 100%;
    }

    .banner_text {
      position: absolute;
      top: 174px;
      left: 360px;

      h4 {
        font-size: 60px;
        font-weight: 600;
        color: #26292c;
      }

      p {
        i {
          display: inline-block;
          width: 7px;
          height: 7px;
          background: #007bff;
          border-radius: 50%;
          vertical-align: middle;
        }

        font-size: 18px;
        font-weight: 400;
        color: #474849;
        margin-top: 18px;
      }
    }

    .try {
      width: 300px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #007bff;
      border: 1px solid #007bff;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      margin-top: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dingding.vue